import { useListSoilSightScenarios, useUserContext } from "utils";

export type SoilSightScenariosAccessBase = {
  hasProject: boolean;
  isLoading: boolean;
  isError: boolean;
  hasScenarios: boolean;
};

// Shared Soil Sight project + scenario list state for route guards.
export const useSoilSightScenariosAccessBase = (): SoilSightScenariosAccessBase => {
  const { user } = useUserContext();
  // Resolve the project from the server pointer on the user object (synchronous, farm-authoritative).
  // The localStorage slot is deliberately not read here: it is farm-agnostic and these guards never
  // reconcile it, so it could surface another farm's project after a farm switch.
  const soilSightProjectId = user?.farm?.soilSightProjectId ?? "";
  const hasProject = Boolean(soilSightProjectId);
  const scenarioListQuery = useListSoilSightScenarios(soilSightProjectId);

  const scenarioList = scenarioListQuery.data;
  const scenarioCount = Array.isArray(scenarioList) ? scenarioList.length : 0;

  if (!hasProject) {
    return { hasProject: false, isLoading: false, isError: false, hasScenarios: false };
  }

  return {
    hasProject: true,
    isLoading: scenarioListQuery.isLoading && scenarioCount === 0,
    isError: scenarioListQuery.isError,
    hasScenarios: scenarioListQuery.isSuccess && scenarioCount >= 1,
  };
};
